import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { jobs } from "../../../../../../redux/jobs/action";
import { selectListItems } from "../../../../../../redux/library/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectJobsListItems } from "../../../../../../redux/jobs/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementJobs = () => {
  const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJobsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'ShipmentInfo.ShipmentPId', headerName: 'ShipmentPID', searchField: 'Message.ShipmentPId', sortable: true, filter: true, filterType: 'text' },
      { field: 'TransportAgentName', headerName: 'Agent', },
      { field: 'IsRTOJOB', headerName: 'RTO JOB', cellRenderer: 'yesNoRenderer' },
      { field: 'IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      {
        field: 'LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      {
        field: 'ShipmentInfo.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false
      },
      { field: `DelayedPickupTime`, headerName: 'Delayed Pickup Time(Mins)' },
      { field: 'PickupCode', headerName: 'Pickup Code' },
      { field: 'PickupInfo.location', headerName: 'From Address', isAddressFormat: true },
      { field: `DelayedDeliveryTime`, headerName: 'Delayed Delivery Time(Mins)' },
      { field: 'DeliveryCode', headerName: 'Delivery Code' },
      { field: 'DeliveryInfo.location', headerName: 'To Address', isAddressFormat: true },
      { field: 'JobNotes', headerName: 'Notes', },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = async () => {
    await dispatch(jobs.resetAction({ actionType: 'list' }))
    await dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/jobs/fetch`, entity: 'jobs', jsonData:
      {
        "Context": {},
        "Records": [{}],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "JobId",
          "SortOrder": "desc",

        }
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchJobs()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(jobs.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/jobs/delete`,
      entity: 'jobs',
      jsonData:
      {
        "Records": [
          {
            "Context": {},
            "Message": {
              "Id": data?.JobId
            }
          }
        ]
      }

    })).then(() => {
      fetchJobs()

    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.JobId}`)
  }
  const handleReloadData = () => {
    fetchJobs()
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "ShipmentPId",
        FieldText: "ShipmentPId",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/jobs/fetch`,
      entity: 'jobs',
      jsonData:
      {
        "Context": {},
        "Records": [{}],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "JobId",
          "SortOrder": "desc",
          "Searches": searchCriteria,
        }
      }
    }));
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Jobs" />
      }
    </>
  );
};

export default ManagementJobs;


